export const xinD = [
  [
    [113.67724605532818, 23.01738427191164, 10],
    [113.67723404399243, 23.017370040407382, 10],
  ],
  [
    [113.67716918154869, 23.017439862712198, 10],
    [113.67715717021083, 23.017425631206024, 10],
  ],
  [
    [113.67709230759387, 23.017495453575783, 10],
    [113.6770802962834, 23.01748122204638, 10],
  ],
  [
    [113.67701543360035, 23.017551044293686, 10],
    [113.67700342226884, 23.01753681277606, 10],
  ],
  [
    [113.67693855951958, 23.01760663508151, 10],
    [113.67692654821548, 23.017592403540643, 10],
  ],
  [
    [113.67686168540013, 23.017662225723644, 10],
    [113.67684967407497, 23.017647994194572, 10],
  ],
  [
    [113.67678481119341, 23.0177178164357, 10],
    [113.67677279989566, 23.01770358488338, 10],
  ],
  [
    [113.67670793694532, 23.017773407094268, 10],
    [113.6766959256318, 23.01775917554993, 10],
  ],
  [
    [113.67663106271291, 23.017828997638393, 10],
    [113.67661905142154, 23.017814766074636, 10],
  ],
  [
    [113.6765541883294, 23.017884588228046, 10],
    [113.6765421770412, 23.017870356658555, 10],
  ],
  [
    [113.67647731388298, 23.01794017868951, 10],
    [113.67646530259795, 23.017925947114296, 10],
  ],
  [
    [113.67640043937354, 23.017995769203385, 10],
    [113.67638842809167, 23.01798153762245, 10],
  ],
  [
    [113.67632356480115, 23.018051359589077, 10],
    [113.67631155352248, 23.018037128002423, 10],
  ],
  [
    [113.67624669016577, 23.01810695002719, 10],
    [113.67623467889027, 23.0180927184348, 10],
  ],
  [
    [113.676169815565, 23.018162540337155, 10],
    [113.67615780429269, 23.018148308739043, 10],
  ],
  [
    [113.67609294080366, 23.018218130699488, 10],
    [113.67608092953452, 23.018203899095656, 10],
  ],
  [
    [113.67601606597941, 23.018273720933635, 10],
    [113.67600405471345, 23.01825948932408, 10],
  ],
  [
    [113.67593919109211, 23.018329311220196, 10],
    [113.67592717982933, 23.01831507960491, 10],
  ],
  [
    [113.67586234381032, 23.01838489806933, 10],
    [113.67585029476201, 23.018370693843572, 10],
  ],
  [
    [113.67578573044035, 23.018440723718463, 10],
    [113.675773604807, 23.018426575438102, 10],
  ],
  [
    [113.67570941954101, 23.018496903279953, 10],
    [113.67569721766988, 23.018482811265983, 10],
  ],
  [
    [113.67563341301164, 23.018553435186668, 10],
    [113.67562113515957, 23.01853939982681, 10],
  ],
  [
    [113.67555771265896, 23.01861031821095, 10],
    [113.6755453591773, 23.018596339822494, 10],
  ],
  [
    [113.67548232047005, 23.018667550792504, 10],
    [113.67546989163941, 23.018653629745906, 10],
  ],
  [
    [113.67540723838671, 23.01872513149521, 10],
    [113.67539473450736, 23.01871126814633, 10],
  ],
  [
    [113.67533246816338, 23.01878305896736, 10],
    [113.67531988953981, 23.018769253669056, 10],
  ],
  [
    [113.6752580116412, 23.01884133177559, 10],
    [113.6752453586038, 23.018827584860524, 10],
  ],
  [
    [113.67518387086511, 23.01889994838991, 10],
    [113.67517114375302, 23.018886260183397, 10],
  ],
  [
    [113.67511004752127, 23.01895890734522, 10],
    [113.67509724661939, 23.018945278215686, 10],
  ],
  [
    [113.67503654354205, 23.019018207213414, 10],
    [113.67502366917395, 23.01900463749867, 10],
  ],
  [
    [113.67496336078156, 23.019077846460863, 10],
    [113.67495041327103, 23.0190643364985, 10],
  ],
  [
    [113.67489050098555, 23.019137823653107, 10],
    [113.67487748067816, 23.019124373762608, 10],
  ],
  [
    [113.67481796602885, 23.019198137239396, 10],
    [113.67480487322896, 23.019184747774265, 10],
  ],
  [
    [113.67474575765746, 23.019258785785027, 10],
    [113.67473259269079, 23.019245457081176, 10],
  ],
  [
    [113.67467387773715, 23.019319767656082, 10],
    [113.67466064090648, 23.019306500069174, 10],
  ],
  [
    [113.67460232807024, 23.01938108154387, 10],
    [113.67458901978205, 23.01936787534068, 10],
  ],
  [
    [113.67453111047509, 23.019442725681312, 10],
    [113.67451773101284, 23.01942958123397, 10],
  ],
  [
    [113.67446022667824, 23.019504698560553, 10],
    [113.67444677638576, 23.019491616189327, 10],
  ],
  [
    [113.6743896784456, 23.01956699873005, 10],
    [113.67437615764835, 23.019553978771324, 10],
  ],
  [
    [113.67431946753408, 23.01962962465576, 10],
    [113.67430587655727, 23.019616667446435, 10],
  ],
  [
    [113.67424959577883, 23.01969257464062, 10],
    [113.67423593498616, 23.01967968048304, 10],
  ],
  [
    [113.67418006484844, 23.01975584723284, 10],
    [113.67416633458487, 23.0197430164459, 10],
  ],
  [
    [113.67411086363622, 23.019819450264155, 10],
    [113.67409708743884, 23.01980666172551, 10],
  ],
  [
    [113.6740417829163, 23.019883208101618, 10],
    [113.67402800671901, 23.019870419557066, 10],
  ],
  [
    [113.67397270213146, 23.019946965908243, 10],
    [113.67395892593424, 23.01993417735779, 10],
  ],
  [
    [113.67390362128167, 23.02001072368404, 10],
    [113.6738898450845, 23.01999793512767, 10],
  ],
  [
    [113.67383454036691, 23.020074481428995, 10],
    [113.67382076416985, 23.020061692866722, 10],
  ],
  [
    [113.67376545938721, 23.020138239143122, 10],
    [113.67375168319022, 23.020125450574938, 10],
  ],
  [
    [113.67369637834257, 23.02020199682641, 10],
    [113.67368260214565, 23.020189208252308, 10],
  ],
  [
    [113.67362729723295, 23.020265754478856, 10],
    [113.6736135210361, 23.02025296589885, 10],
  ],
  [
    [113.67355821605838, 23.020329512100474, 10],
    [113.67354443986163, 23.020316723514554, 10],
  ],
  [
    [113.67348913481888, 23.020393269691244, 10],
    [113.67347535862217, 23.020380481099416, 10],
  ],
  [
    [113.6734200535144, 23.020457027251187, 10],
    [113.6734062773178, 23.020444238653454, 10],
  ],
  [
    [113.67335097214497, 23.020520784780288, 10],
    [113.67333719594843, 23.020507996176644, 10],
  ],
  [
    [113.67328189070082, 23.02058454228758, 10],
    [113.6732681145239, 23.020571753659972, 10],
  ],
  [
    [113.67321280920149, 23.020648299755006, 10],
    [113.67319903302464, 23.020635511121487, 10],
  ],
];
